import { render, staticRenderFns } from "./QJSQ.vue?vue&type=template&id=55f29af0&scoped=true"
import script from "./QJSQ.vue?vue&type=script&lang=js"
export * from "./QJSQ.vue?vue&type=script&lang=js"
import style0 from "./QJSQ.vue?vue&type=style&index=0&id=55f29af0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f29af0",
  null
  
)

export default component.exports